/**
 * Empty states
 */

import { MAP_WIDTH, MAP_HEIGHT } from "../constants";

import type { Map, Schedule, Font, LayoutSettings } from "../types";

export const emptyMap: Map = {
  id: "empty",
  title: "Empty",
  connectionColor: "#ff2244",
  backgroundColor: "#111111",
  waypointColor: "#ffff00",
  textStrokeColor: null,
  pinColor: null,
  textColor: "#ffffff",
  fonts: [],
  places: [],
  textboxes: [],
  waypoints: [],
  icons: [],
  template: {
    id: "empty",
    name: "Empty",
    height: MAP_HEIGHT,
    width: MAP_WIDTH,
    rotation: 0,
    layers: [],
    layerImages: [],
    geopoints: []
  }
};

export const emptySchedule: Schedule = {
  id: "empty",
  title: "Empty",
  eventHours: []
};

export const emptyFont: Font = {
  id: "empty",
  fontName: "var(--font-system)",
  fontWeight: 500,
  preconnectUrl: null,
  resourceUrl: null
};

export const emptySettings: LayoutSettings = {
  theme: null,
  name: "Mobile App",
  description: "All facility information.",
  favicon: null,
  touchIcon: null,
  hero: null,
  gtmContainerId: null,
  showSchedule: false,
  showEventEndTime: false,
  showHome: false,
  showMap: false,
  tenant: "empty"
};
